/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';

import { pick } from 'lodash';

const __vue_script__ = {
    name: 'MetadataTypePresentation',

    components: {
        BaseInput,
        ExpandableContent,
    },

    props: {
        type: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            innerValue: pick(this.type, this.$utils.metadata.REPRESENTATIONS),
            showFullRepresentations: false
        };
    },

    computed: {
        chevronClass() {
            return `ic-chevron-${this.showFullRepresentations ? 'up' : 'down'}`;
        }
    },

    methods: {
        toggleShowFull() {
            this.showFullRepresentations = !this.showFullRepresentations;
        },

        onInput(value, key) {
            this.$store.commit('setRepresentationField', { key, value });
        }

    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"type-representations",class:{ 'show-full-representations' : _vm.showFullRepresentations }},[_c('h5',[_vm._v(_vm._s(_vm.$t("metadata_editor.titles.representation")))]),_c('i18n',{staticClass:"editor-caption",attrs:{"path":"metadata_editor.representation.description","tag":"p"}},[_c('code',[_vm._v("{{")]),_c('code',[_vm._v("}}")])]),_vm._l((_vm.$utils.metadata.REPRESENTATIONS),function(representation){return _c('p',{staticClass:"type-representation"},[_c('base-input',{attrs:{"name":representation,"value":_vm.innerValue[representation],"label":_vm.$t(("metadata_editor.representation." + representation))},on:{"input":function($event){return _vm.onInput($event, representation)}}})],1)}),_c('a',{staticClass:"has-action",attrs:{"role":"button","href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleShowFull.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(_vm.$t(("general.show_" + (_vm.showFullRepresentations ? 'less' : 'more')))))]),_c('i',{class:[_vm.chevronClass]})])],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "TypeRepresentations.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__